import { useQuery } from '@apollo/client';
import { getGlobalComponentList } from "../gqls/useGetGlobalComponentList";
/**
 * 拿取全域元件：彈窗廣告 !!目前只允許建立一組彈窗廣告
 *
 * @returns {{ globalPopup: GlobalComponent; }}
 */

var useGetGlobalPopup = function useGetGlobalPopup() {
  var _data$getGlobalCompon;

  var _useQuery = useQuery(getGlobalComponentList, {
    variables: {
      input: {
        type: 'POPUP'
      }
    }
  }),
      data = _useQuery.data;

  var globalPopup = data === null || data === void 0 ? void 0 : (_data$getGlobalCompon = data.getGlobalComponentList) === null || _data$getGlobalCompon === void 0 ? void 0 : _data$getGlobalCompon[0];
  return {
    globalPopup: globalPopup
  };
};

export default useGetGlobalPopup;